import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router";
import logo from "../assets/logo.png";
import icon from "../assets/logo.ico";
import screenshot1 from "../assets/1.png";

export function meta() {
  return [
    {
      title:
        "شروط وأحكام الاستخدام - أديم المناسبات | الشروط القانونية والسياسات",
    },
    {
      name: "description",
      content:
        "تعرف على شروط وأحكام استخدام تطبيق أديم المناسبات، الشروط القانونية وسياسات الاستخدام المعمول بها. شروط مزود الخدمة والعميل وسياسات الإلغاء والاسترداد.",
    },
    {
      name: "keywords",
      content:
        "شروط الاستخدام، أحكام أديم، قوانين التطبيق، سياسة الخصوصية، شروط مزود الخدمة، شروط العميل، سياسة الإلغاء، سياسة الاسترداد، شروط المناسبات، أحكام قانونية، السعودية",
    },
    {
      name: "author",
      content: "أديم المناسبات",
    },
    {
      name: "robots",
      content: "index, follow",
    },
    {
      name: "language",
      content: "Arabic",
    },
    {
      name: "geo.region",
      content: "SA",
    },
    {
      name: "geo.country",
      content: "Saudi Arabia",
    },
    {
      name: "geo.placename",
      content: "المملكة العربية السعودية",
    },
    {
      name: "apple-mobile-web-app-capable",
      content: "yes",
    },
    {
      name: "apple-mobile-web-app-status-bar-style",
      content: "black-translucent",
    },
    {
      name: "apple-mobile-web-app-title",
      content: "أديم المناسبات - شروط وأحكام",
    },
    {
      name: "mobile-web-app-capable",
      content: "yes",
    },
    {
      name: "theme-color",
      content: "#58654C",
    },
    {
      name: "msapplication-TileColor",
      content: "#58654C",
    },
    // Open Graph Meta Tags
    {
      property: "og:title",
      content:
        "شروط وأحكام الاستخدام - أديم المناسبات | الشروط القانونية والسياسات",
    },
    {
      property: "og:description",
      content:
        "تعرف على شروط وأحكام استخدام تطبيق أديم المناسبات والالتزامات القانونية. شروط مزود الخدمة والعميل وسياسات الإلغاء والاسترداد في المملكة العربية السعودية.",
    },
    {
      property: "og:image",
      content: logo,
    },
    {
      property: "og:image:width",
      content: "1200",
    },
    {
      property: "og:image:height",
      content: "630",
    },
    {
      property: "og:image:alt",
      content: "أديم المناسبات - شروط وأحكام الاستخدام",
    },
    {
      property: "og:url",
      content: "https://adim-app.com/terms",
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "og:site_name",
      content: "أديم المناسبات",
    },
    {
      property: "og:locale",
      content: "ar_SA",
    },
    // Twitter Card Meta Tags
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:title",
      content: "شروط وأحكام الاستخدام - أديم المناسبات",
    },
    {
      name: "twitter:description",
      content:
        "تعرف على شروط وأحكام استخدام تطبيق أديم المناسبات والالتزامات القانونية في المملكة العربية السعودية.",
    },
    {
      name: "twitter:image",
      content: logo,
    },
    {
      name: "twitter:image:alt",
      content: "أديم المناسبات - شروط وأحكام الاستخدام",
    },
    // App Store Meta Tags
    {
      name: "apple-itunes-app",
      content: "app-id=app-id=6758246638",
    },
    {
      name: "google-play-app",
      content: "app-id=com.adim.events",
    },
    // Canonical URL
    {
      tagName: "link",
      rel: "canonical",
      href: "https://adim-app.com/terms",
    },
    // Favicon
    {
      tagName: "link",
      rel: "icon",
      type: "image/x-icon",
      href: icon,
    },
    {
      tagName: "link",
      rel: "apple-touch-icon",
      href: logo,
    },
    // Structured Data JSON-LD
    {
      tagName: "script",
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "شروط وأحكام الاستخدام - أديم المناسبات",
        description:
          "شروط وأحكام استخدام تطبيق أديم المناسبات في المملكة العربية السعودية",
        url: "https://adim-app.com/terms",
        isPartOf: {
          "@type": "WebSite",
          name: "أديم المناسبات",
          url: "https://adim-app.com",
        },
        inLanguage: "ar-SA",
        publisher: {
          "@type": "Organization",
          name: "أديم المناسبات",
          url: "https://adim-app.com",
          logo: logo,
        },
      }),
    },
  ];
}

export default function Terms() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("general");

  // Add/remove body class when menu opens/closes
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }

    // Cleanup on unmount
    return () => {
      document.body.classList.remove("menu-open");
    };
  }, [isMenuOpen]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#58654C]">
      
      {/* Header / Nav */}
      <header className="fixed top-0 left-0 right-0 z-40 bg-[#58654C] backdrop-blur-md border-b-2 border-[#BFA15D] shadow-xl md:mx-[6em] mx-[1em] mt-[.5em] rounded-[5em]">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <nav
            className="flex items-center justify-between h-16 lg:h-20"
            role="navigation"
            aria-label="القائمة الرئيسية"
          >
            {/* Logo */}
            <div className="flex items-center space-x-3 rtl:space-x-reverse">
              <img
                src={logo}
                alt="شعار أديم المناسبات"
                className="h-10 lg:h-12 brightness-0 invert"
                height="48"
              />
            </div>

            {/* Desktop Navigation */}
            <ul
              className="hidden md:flex items-center rtl:space-x-reverse gap-[2em]"
              role="menubar"
            >
              <li role="menuitem">
                <Link
                  to="/"
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى الصفحة الرئيسية"
                >
                  الرئيسية
                </Link>
              </li>
              <li role="menuitem">
                <button
                  onClick={() => {
                    navigate("/");
                    setTimeout(() => {
                      document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                  }}
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم خدماتنا"
                >
                  خدماتنا
                </button>
              </li>
              <li role="menuitem">
                <button
                  onClick={() => {
                    navigate("/");
                    setTimeout(() => {
                      document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                  }}
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم لماذا أديم"
                >
                  لماذا أديم
                </button>
              </li>
              <li role="menuitem">
                <button
                  onClick={() => {
                    navigate("/");
                    setTimeout(() => {
                      document.getElementById("screenshots")?.scrollIntoView({ behavior: "smooth" });
                    }, 100);
                  }}
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="الذهاب إلى قسم شاشات التطبيق"
                >
                  شاشات التطبيق
                </button>
              </li>
              <li role="menuitem">
                <span
                  className="text-[#BFA15D] transition-colors duration-200 text-sm font-medium cursor-default"
                  aria-label="شروط وأحكام الاستخدام (الصفحة الحالية)"
                >
                  شروط وأحكام الاستخدام  
                </span>
              </li>
              <li role="menuitem">
                <Link
                  to="/privacy"
                  className="text-white transition-colors duration-200 text-sm font-medium cursor-pointer hover:text-[#BFA15D]"
                  aria-label="سياسة الخصوصية"
                >
                  سياسة الخصوصية
                </Link>
              </li>
            </ul>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden p-2 rounded-lg text-white hover:bg-white/10 transition-all duration-300 hover:scale-110 transform"
              aria-expanded={isMenuOpen}
              aria-controls="mobile-menu"
              aria-label={isMenuOpen ? "إغلاق القائمة" : "فتح القائمة"}
            >
              <svg
                className={`w-6 h-6 transition-transform duration-300 ${isMenuOpen ? "rotate-90 scale-90" : "rotate-0 scale-100"}`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={
                    isMenuOpen
                      ? "M6 18L18 6M6 6l12 12"
                      : "M4 6h16M4 12h16M4 18h16"
                  }
                />
              </svg>
            </button>
          </nav>
        </div>
      </header>
      {/* Mobile Menu */}
      {isMenuOpen && (
        <div
          className="mobile-menu-overlay md:hidden fixed inset-0 bg-[#58654C] transition-all duration-500 ease-in-out opacity-100 visible animate-fadeIn"
          style={{
            zIndex: "999999 !important",
            backgroundColor: "#58654C",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            margin: 0,
            padding: 0,
            animation: "fadeInUp 0.5s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
        >
          {/* Menu Content */}
          <div className="relative h-full flex flex-col animate-slideInUp">
            {/* Header with Close Button */}
            <div
              className="flex items-center justify-between p-6 border-b border-white/20 animate-slideInDown"
              style={{ animationDelay: "0.1s" }}
            >
              <div className="flex items-center gap-3">
                <img
                  src={logo}
                  alt="أديم"
                  className="h-8 brightness-0 invert animate-bounceIn"
                  style={{ animationDelay: "0.3s" }}
                />
              </div>

              <button
                onClick={() => setIsMenuOpen(false)}
                className="p-2 rounded-lg text-white hover:bg-white/10 transition-all duration-300 hover:scale-110 hover:rotate-90 animate-fadeInRight"
                style={{ animationDelay: "0.2s" }}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Navigation Links */}
            <div
              className="flex-1 flex flex-col justify-start items-start px-1 text-right animate-fadeInUp mt-8"
              style={{ animationDelay: "0.4s" }}
            >
              <Link
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.5s" }}
              >
                الرئيسية
              </Link>
              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  navigate("/");
                  setTimeout(() => {
                    document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.5s" }}
              >
                خدماتنا
              </button>
              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  navigate("/");
                  setTimeout(() => {
                    document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.6s" }}
              >
                لماذا أديم
              </button>
              <button
                onClick={() => {
                  setIsMenuOpen(false);
                  navigate("/");
                  setTimeout(() => {
                    document.getElementById("screenshots")?.scrollIntoView({ behavior: "smooth" });
                  }, 100);
                }}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.7s" }}
              >
                شاشات التطبيق
              </button>
               <span
                className="block w-full py-4 text-[#BFA15D] text-md font-medium px-4 text-right transition-all duration-300 animate-slideInLeft"
                style={{ animationDelay: "0.7s" }}
              >
                شروط وأحكام الاستخدام
              </span>
               <Link
                to="/privacy"
                onClick={() => setIsMenuOpen(false)}
                className="block w-full py-4 text-white text-md font-medium px-4 text-right hover:text-[#BFA15D] transition-all duration-300 hover:scale-105 hover:translate-x-2 animate-slideInLeft"
                style={{ animationDelay: "0.8s" }}
              >
                سياسة الخصوصية
              </Link>
            </div>

            {/* Screenshot Display - Bottom Half */}
            <div
              className="relative h-100 overflow-hidden animate-fadeInUp rounded flex justify-center"
              style={{ animationDelay: "0.9s" }}
            >
              <img
                src={screenshot1}
                alt="شاشة التطبيق"
                className="absolute bottom-[-7em] w-auto h-full object-top rounded"
              />
            </div>
          </div>
        </div>
      )}
      {/* Main Content */}
      <main id="main" role="main">
        {/* Hero Section */}
        <section className="pt-32 pb-16 lg:pb-24 bg-gradient-to-br to-white via-gray-50 from-[#58654C]/10">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-6xl mx-auto">
              <div className="flex flex-col lg:flex-row justify-center items-center gap-12 lg:gap-16">
                <div className="relative bg-gradient-to-r from-[#58654C]/5 to-[#BFA15D]/5 rounded-3xl p-8 lg:p-12">
                  <h1 className="text-2xl sm:text-3xl lg:text-3xl font-bold text-[#58654C] mb-6 leading-10 text-center px-5">
                    شروط وأحكام استخدام تطبيق أديم المناسبات
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Tabs Navigation */}
        <section className="py-12 bg-white">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-2xl lg:text-3xl font-bold text-[#58654C] mb-4">
                  فهرس المحتويات
                </h2>
                <p className="text-gray-600 max-w-2xl mx-auto text-md">
                  انقر على أي قسم للانتقال إليه مباشرة
                </p>
              </div>

              {/* Tabs Navigation */}
              <div className="grid grid-cols-2 sm:flex flex-wrap justify-center gap-2 mb-8 p-2 bg-gray-100 rounded-xl">
                <button
                  onClick={() => setActiveTab("general")}
                  className={`flex-1 min-w-0 px-6 py-4 text-center font-medium rounded-lg transition-all duration-200 focus:outline-none ${
                    activeTab === "general"
                      ? "bg-[#58654C] text-white shadow-md"
                      : "text-gray-600 hover:text-[#58654C] hover:bg-white"
                  }`}
                >
                  <div className="text-sm font-bold mb-1">القسم الأول</div>
                  <div className="text-xs hidden sm:block opacity-80">
                    أحكام عامة
                  </div>
                </button>

                <button
                  onClick={() => setActiveTab("provider")}
                  className={`flex-1 min-w-0 px-6 py-4 text-center font-medium rounded-lg transition-all duration-200 focus:outline-none ${
                    activeTab === "provider"
                      ? "bg-[#58654C] text-white shadow-md"
                      : "text-gray-600 hover:text-[#58654C] hover:bg-white"
                  }`}
                >
                  <div className="text-sm font-bold mb-1">القسم الثاني</div>
                  <div className="text-xs hidden sm:block opacity-80">
                    مزود الخدمة
                  </div>
                </button>

                <button
                  onClick={() => setActiveTab("client")}
                  className={`flex-1 min-w-0 px-6 py-4 text-center font-medium rounded-lg transition-all duration-200 focus:outline-none ${
                    activeTab === "client"
                      ? "bg-[#58654C] text-white shadow-md"
                      : "text-gray-600 hover:text-[#58654C] hover:bg-white"
                  }`}
                >
                  <div className="text-sm font-bold mb-1">القسم الثالث</div>
                  <div className="text-xs hidden sm:block opacity-80">
                    العميل
                  </div>
                </button>

                <button
                  onClick={() => setActiveTab("policies")}
                  className={`flex-1 min-w-0 px-6 py-4 text-center font-medium rounded-lg transition-all duration-200 focus:outline-none ${
                    activeTab === "policies"
                      ? "bg-[#58654C] text-white shadow-md"
                      : "text-gray-600 hover:text-[#58654C] hover:bg-white"
                  }`}
                >
                  <div className="text-sm font-bold mb-1">القسم الرابع</div>
                  <div className="text-xs hidden sm:block opacity-80">
                    السياسات
                  </div>
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Terms Content */}
        <div className="py-16 bg-gray-50">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-5xl mx-auto">
              {/* Section 1: General Terms */}
              {activeTab === "general" && (
                <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200 animate-fadeIn">
                  <h2 className="text-xl font-bold text-[#58654C] mb-8 text-center border-b border-gray-200 pb-4">
                    القسم الأول: أحكام عامة (تطبق على الجميع)
                  </h2>

                  <div className="bg-gradient-to-r to-[#BFA15D]/10 via-transparent from-[#BFA15D]/10 border-r-4  p-6 mb-8 rounded-lg text-center">
                    <p className="text-lg text-gray-700 leading-relaxed">
                      <strong>مرحبًا بك في تطبيق أديم المناسبات.</strong>
                      <br />
                      <p className="p-0 m-0 text-sm mt-2">
                        باستخدامك للتطبيق أو تسجيلك فيه (كعميل أو كمزود خدمة)،
                        فإنك تقر بموافقتك الكاملة والملزمة على هذه الشروط.
                      </p>
                    </p>
                  </div>

                  <div className="space-y-8">
                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        طبيعة المنصة
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • أديم المناسبات منصة تقنية إلكترونية تعمل كوسيط فقط
                          بين العملاء ومزودي خدمات المناسبات.
                        </p>
                        <p>
                          • لا تقدم المنصة أي خدمة ميدانية بنفسها، ولا تعد طرفًا
                          في تنفيذ الخدمات أو الاتفاقات.
                        </p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        النزاعات بين العميل ومزود الخدمة
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • في حال نشوء أي نزاع أو خلاف أو مطالبة بين العميل
                          ومزود الخدمة، تكون العلاقة التعاقدية قائمة بينهما
                          مباشرة دون أي مسؤولية على المنصة.
                        </p>
                        <p>
                          • لا تعد المنصة طرفًا في أي عقد أو التزام ناشئ بين
                          الطرفين، ولا تتحمل أي التزام مالي أو قانوني أو تعويضي
                          نتيجة هذا النزاع.
                        </p>
                        <p>
                          • يجوز للمنصة – دون التزام – المساعدة في التواصل بين
                          الطرفين عبر قنوات الدعم الفني فقط، دون أن يترتب على
                          ذلك أي مسؤولية أو ضمان.
                        </p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        التسجيل واستخدام الحساب
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>• يلتزم المستخدم بتقديم بيانات صحيحة ومحدثة.</p>
                        <p>
                          • يتحمل المستخدم المسؤولية الكاملة عن أي بيانات غير
                          صحيحة أو مضللة.
                        </p>
                        <p>
                          • يحق للمنصة تعليق أو إلغاء أي حساب في حال مخالفة
                          الشروط أو إساءة الاستخدام.
                        </p>
                      </div>
                    </div>

                    <div className="bg-gray-50 border  rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        التعامل خارج التطبيق
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • يمنع الاتفاق بين العميل ومزود الخدمة خارج التطبيق
                          بقصد التهرب من العمولة.
                        </p>
                        <p>
                          • مخالفة ذلك تعرض الحساب للحظر النهائي دون أي حقوق
                          مالية.
                        </p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        حدود المسؤولية التقنية
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • لا تضمن المنصة توفر الخدمة بشكل دائم أو خلوها من
                          الأخطاء.
                        </p>
                        <p>
                          • لا تتحمل المنصة أي مسؤولية عن الأعطال التقنية أو
                          انقطاع الخدمة.
                        </p>
                      </div>
                    </div>

                    <div className="bg-gray-50 border  rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        القانون المعمول به
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • تخضع هذه الشروط لأنظمة المملكة العربية السعودية،
                          وتختص المحاكم السعودية بالنظر في أي نزاع.
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {/* Section 2: Provider Obligations */}
              {activeTab === "provider" && (
                <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200 animate-fadeIn">
                  <h2 className="text-xl font-bold text-[#58654C] mb-8 text-center border-b border-gray-200 pb-4">
                    القسم الثاني: التزامات مزود الخدمة
                  </h2>
                  <div className="space-y-8">
                    <div className="bg-gray-50 border  rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C]  mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        المستندات النظامية
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          <strong className="text-[#58654C] text-sm">
                            يشترط للتسجيل كمزود خدمة تقديم
                          </strong>
                        </p>
                        <p>• سجل تجاري ساري، أو وثيقة عمل حر سارية.</p>
                        <p>
                          • يتحمل مزود الخدمة المسؤولية النظامية الكاملة عن صحة
                          هذه المستندات.
                        </p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        جودة الخدمة
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • يلتزم مزود الخدمة بتنفيذ الخدمة بجودة مناسبة ووفق ما
                          تم الاتفاق عليه مع العميل.
                        </p>
                        <p>• يتحمل وحده أي مسؤولية عن الإخلال بالتنفيذ.</p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        سياسة الإلغاء الخاصة بالمزود
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • يلتزم مزود الخدمة بتحديد سياسة إلغاء واضحة في ملفه.
                        </p>
                        <p>• تكون هذه السياسة ملزمة له وللعميل.</p>
                      </div>
                    </div>

                    <div className="bg-gray-50 border  rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C]  mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        العمولة
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • تحصل المنصة على عمولة قدرها <strong>14%</strong> من
                          قيمة كل طلب يتم عبر التطبيق.
                        </p>
                        <p>
                          • يتم خصم العمولة تلقائيًا من إجمالي قيمة الطلب قبل
                          تحويل مستحقات مزود الخدمة.
                        </p>
                        <p>
                          • العمولة غير قابلة للاسترجاع بعد قبول الطلب أو
                          تنفيذه.
                        </p>
                      </div>
                    </div>

                    <div className="bg-gray-50 border  rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C]  mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        الضرائب والالتزامات النظامية
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          <strong>
                            يتحمل مزود الخدمة وحده جميع الالتزامات النظامية، بما
                            في ذلك:
                          </strong>
                        </p>
                        <p>• الزكاة</p>
                        <p>• ضريبة القيمة المضافة</p>
                        <p>• التراخيص والتصاريح</p>
                        <p>
                          <strong>
                            لا تتحمل المنصة أي مسؤولية ضريبية عن دخل مزودي
                            الخدمة.
                          </strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {/* Section 3: Client Rights and Obligations */}
              {activeTab === "client" && (
                <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200 animate-fadeIn">
                  <h2 className="text-xl font-bold text-[#58654C] mb-8 text-center border-b border-gray-200 pb-4">
                    القسم الثالث: حقوق والتزامات العميل
                  </h2>
                  <div className="space-y-8">
                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        الطلب والدفع
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • يتم الدفع عبر وسائل الدفع المعتمدة داخل التطبيق فقط.
                        </p>
                        <p>
                          • لا تتحمل المنصة مسؤولية أي تعاملات خارج النظام
                          المعتمد.
                        </p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        صحة بيانات الطلب
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • يلتزم العميل بإدخال بيانات صحيحة للطلب (الموعد،
                          الموقع، التفاصيل).
                        </p>
                        <p>• يتحمل العميل أي أضرار ناتجة عن خطأ في بياناته.</p>
                      </div>
                    </div>

                    <div className="bg-gray-50 rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C] mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        التقييم
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>• يلتزم العميل باستخدام نظام التقييم بصدق وأمانة.</p>
                        <p>• يمنع استخدام التقييم للإساءة أو التشهير.</p>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {/* Section 4: Shared Policies */}
              {activeTab === "policies" && (
                <section className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200 animate-fadeIn">
                  <h2 className="text-xl font-bold text-[#58654C] mb-8 text-center border-b border-gray-200 pb-4">
                    القسم الرابع: السياسة المشتركة (الإلغاء والاسترداد)
                  </h2>
                  <div className="space-y-8">
                    <div className="bg-gray-50 border  rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C]  mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        الإلغاء
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • تخضع عمليات الإلغاء لسياسة مزود الخدمة المعلنة في
                          ملفه.
                        </p>
                        <p>
                          • يقر العميل بالاطلاع على سياسة الإلغاء والموافقة
                          عليها قبل إتمام الطلب.
                        </p>
                      </div>
                    </div>

                    <div className="bg-gray-50 border  rounded-lg p-6">
                      <h3 className="text-lg font-bold text-[#58654C]  mb-4 flex items-center">
                        <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                        الاسترداد
                      </h3>
                      <div className="text-gray-700 space-y-3 text-right leading-relaxed text-sm">
                        <p>
                          • يتم استرداد المبلغ للعميل وفق سياسة الإلغاء الخاصة
                          بمزود الخدمة.
                        </p>
                        <p>
                          • تقتصر مسؤولية المنصة على تنفيذ التعليمات المالية حسب
                          نتيجة سياسة الإلغاء فقط.
                        </p>
                        <p>
                          • قد لا تكون الرسوم البنكية أو رسوم بوابات الدفع (مثل
                          مدى، فيزا، ماستر كارد) مستردة في بعض حالات الإلغاء،
                          ويتحملها الطرف المستفيد من عملية الإلغاء حسب سياسة
                          مزود الخدمة.
                        </p>
                        <p>
                          • لا تتحمل المنصة أي التزام مالي خارج ما تقرره سياسة
                          الإلغاء.
                        </p>
                      </div>
                    </div>

                    {/* أحكام ختامية */}
                    <div className="bg-gray-50 border-gray-300 rounded-lg p-6 mt-8">
                      <h3 className="text-xl font-bold text-[#58654C] mb-6 ">
                        أحكام ختامية
                      </h3>

                      <div className="space-y-6">
                        <div className="bg-white rounded-lg p-4">
                          <h4 className="text-lg font-bold text-[#58654C] mb-3 flex items-center text-sm">
                            <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                            حماية البيانات
                          </h4>
                          <p className="text-gray-700 text-right leading-relaxed">
                            تلتزم المنصة بمعالجة وحماية البيانات الشخصية وفق
                            نظام حماية البيانات الشخصية المعمول به في المملكة
                            العربية السعودية.
                          </p>
                        </div>

                        <div className="bg-white rounded-lg p-4">
                          <h4 className="font-bold text-[#58654C] mb-3 flex items-center text-sm">
                            <span className="w-2 h-2 bg-[#BFA15D] rounded-full ml-3"></span>
                            التعديلات
                          </h4>
                          <p className="text-gray-700 text-right leading-relaxed">
                            يحق للمنصة تعديل هذه الشروط في أي وقت، ويعد استمرار
                            الاستخدام بعد التعديل موافقة ضمنية.
                          </p>
                        </div>

                        <div className="bg-gradient-to-r from-[#58654c5c]  to-[#bfa25d5c] rounded-lg p-6 text-black">
                          <h4 className=" font-bold mb-3 flex items-center text-sm ">
                            <span className="text-2xl ml-3">✓</span>
                            الموافقة
                          </h4>
                          <p className=" leading-relaxed text-sm">
                            <strong>
                              أوافق على شروط وأحكام الاستخدام، وسياسة الخصوصية،
                              وأقر بصحة البيانات المقدمة، وأتعهد بالالتزام
                              بسياسات العمولة والتعاملات المالية داخل التطبيق.
                            </strong>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              {/* Contact Section */}
              <section className="bg-[#58654C] rounded-2xl shadow-lg p-8 text-center mt-16">
                <h2 className="text-2xl font-bold text-white mb-6">
                  هل لديك استفسارات؟
                </h2>
                <p className="text-white/90 mb-8 leading-relaxed text-sm">
                  إذا كان لديك أي أسئلة حول شروط وأحكام الاستخدام، يمكنك التواصل
                  معنا
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                  <a
                    href="mailto:info@adim-app.com"
                    className="bg-white text-[#58654C] px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors duration-200"
                  >
                    info@adim-app.com
                  </a>
                  <a
                    href="tel:+966557076035"
                    className="bg-[#BFA15D] text-white px-6 py-3 rounded-lg font-medium hover:bg-[#BFA15D]/80 transition-colors duration-200"
                  >
                    0557076035
                  </a>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#3E4736] text-white py-12 lg:py-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row items-start md:items-center justify-between gap-8">
            {/* Logo & Description */}
            <div className="flex flex-col justify-center items-start md:items-center ">
              <div className="flex flex-col justify-center items-start md:items-center gap-4 mb-4">
                <img
                  src={logo}
                  alt="أديم"
                  className="h-10 lg:h-12 brightness-0 invert"
                />
                <div className="flex flex-col justify-center items-center ">
                  <div className="text-white text-md lg:text-md font-bold">
                    منصتك الأولى لحجز خدمات المناسبات
                  </div>
                </div>
              </div>

              <p className="text-white max-w-md text-sm lg:text-sm leading-relaxed md:text-center">
                نجعل كل مناسبة تجربة استثنائية من خلال توفير أفضل الخدمات
                والمقدمين المعتمدين في المملكة العربية السعودية.
              </p>
            </div>

            {/* Links & Contact */}
            <div className="flex flex-col sm:flex-row gap-10 lg:gap-[10em] text-center">
              {/* Quick Links */}
              <div className="flex flex-col items-start justify-center">
                <h4 className="font-bold text-md mb-4 text-white">
                  روابط سريعة
                </h4>
                <ul className="space-y-2 text-gray-400 flex flex-col items-start justify-center">
                  <li>
                    <Link
                      to="/"
                      className="text-white text-sm hover:text-[#BFA15D] transition-colors duration-200"
                    >
                      الرئيسية
                    </Link>
                  </li>
                  <li>
                    <span
                      className="text-[#BFA15D] text-sm transition-colors duration-200 cursor-default"
                    >
                      شروط وأحكام الاستخدام
                    </span>
                  </li>
                  <li>
                    <Link
                      to="/privacy"
                      className="text-white text-sm hover:text-[#BFA15D] transition-colors duration-200"
                    >
                      سياسة الخصوصية
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Contact Info */}
              <div className="flex flex-col items-start justify-center">
                <h4 className="font-bold text-md mb-4 text-white">
                  تواصل معنا
                </h4>
                <ul className="space-y-2 text-gray-400 flex flex-col items-start justify-center">
                  <li className="flex items-center justify-center sm:justify-start gap-2 text-white text-sm">
                    info@adim-app.com
                  </li>
                  <li className="flex items-center justify-center sm:justify-start gap-2 text-white text-sm">
                    <a href="tel:+966557076035">0557076035</a>
                  </li>
                 
                  <li className="flex items-center justify-center sm:justify-start gap-2 text-white text-sm">
                    الرياض - المملكة العربية السعودية
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t-[.005em] border-white mt-[5em] pt-8 text-center">
            <p className="text-white text-sm lg:sm font-bold">
              © 2026 أديم المناسبات. جميع الحقوق محفوظة.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
